import { useEffect, useState } from "react";
import useIsMiniProgram from "./useIsMiniProgram";
import { BREAKPOINTS } from "./useResponsiveness";

const useIsTabletPortrait = () => {
  const [isTabletPortrait, setIsTabletPortrait] = useState(false);
  const isMiniProgram = useIsMiniProgram();

  useEffect(() => {
    const checkTabletPortrait = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      setIsTabletPortrait(width <= BREAKPOINTS.lg && height > width);
    };

    checkTabletPortrait();

    window.addEventListener("resize", checkTabletPortrait);

    return () => {
      window.removeEventListener("resize", checkTabletPortrait);
    };
  }, []);

  return isTabletPortrait && !isMiniProgram;
};

export default useIsTabletPortrait;
